import DESTINATIONS_DB from '@/data/destinations.json'
import { AIRPORT_DB } from '@/data/airports'

function slugify(name) {
  return name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export const DURATION_TO_SLUG = {
  weekend:    'weekend',
  '1_week':   'week',
  '2_weeks':  '2-weeks',
  lh_2_weeks: '2-weeks',
}
export const SLUG_TO_DURATIONS = {
  weekend:   ['weekend'],
  week:      ['1_week'],
  '2-weeks': ['2_weeks', 'lh_2_weeks'],
}
export const DURATION_SLUG_LABEL = {
  weekend:  'Weekend',
  week:     '1 week',
  '2-weeks':'2 weeks',
}

// Origin slug → IATA, sorted longest-first so 'london-heathrow' beats 'london'
const ORIGIN_MAP = Object.fromEntries(
  Object.entries(AIRPORT_DB).map(([iata, d]) => [slugify(d.city), iata])
)
const ORIGIN_ENTRIES = Object.entries(ORIGIN_MAP).sort((a, b) => b[0].length - a[0].length)

// City slug → [IATA, ...] — groups multi-airport cities (Milan, Rome, London, Tenerife…)
export const CITY_TO_IATAS = {}
for (const [iata, d] of Object.entries(DESTINATIONS_DB)) {
  if (!d.city_name) continue
  const cs = slugify(d.city_name)
  if (!CITY_TO_IATAS[cs]) CITY_TO_IATAS[cs] = []
  CITY_TO_IATAS[cs].push(iata)
}

// Slug helpers
export const originSlug = iata => slugify(AIRPORT_DB[iata]?.city || iata)
export const destSlug   = iata => slugify(DESTINATIONS_DB[iata]?.city_name || iata)
export const routeSlug  = (o, d) => `${originSlug(o)}-${destSlug(d)}`
export const dealSlug   = (o, d, dur) =>
  `${routeSlug(o, d)}-${DURATION_TO_SLUG[dur] || slugify(dur)}`

// Returns { origin, destinations: [IATA, ...] } — always an array, multi-airport cities included
export function parseRouteSlug(slug) {
  for (const [os, originIata] of ORIGIN_ENTRIES) {
    if (!slug.startsWith(os + '-')) continue
    const cs = slug.slice(os.length + 1)
    const destinations = CITY_TO_IATAS[cs]
    if (destinations?.length) return { origin: originIata, destinations }
  }
  return null
}

export function parseDealSlug(slug) {
  const durSlugs = Object.keys(SLUG_TO_DURATIONS).sort((a, b) => b.length - a.length)
  for (const ds of durSlugs) {
    if (!slug.endsWith('-' + ds)) continue
    const routePart = slug.slice(0, -(ds.length + 1))
    const route = parseRouteSlug(routePart)
    if (route) return { ...route, durationSlug: ds, durations: SLUG_TO_DURATIONS[ds] }
  }
  return null
}

export const originLabel = iata => AIRPORT_DB[iata]?.city || iata
export const destLabel   = iata => DESTINATIONS_DB[iata]?.city_name || iata

// For multi-airport cities, label = city name of first IATA
export const cityLabel = iatas =>
  destLabel(Array.isArray(iatas) ? iatas[0] : iatas)

export const routeLabel = (o, destinations) =>
  `${originLabel(o)} → ${cityLabel(destinations)}`

export const dealLabel = (o, destinations, ds) =>
  `${routeLabel(o, destinations)} ${DURATION_SLUG_LABEL[ds] || ds}`

export function flagEmoji(countryCode) {
  if (!countryCode) return ''
  return countryCode
    .toUpperCase()
    .split('')
    .map(c => String.fromCodePoint(c.charCodeAt(0) + 127397))
    .join('')
}
